import { render, staticRenderFns } from "./Pendency.vue?vue&type=template&id=6da70799"
import script from "./Pendency.vue?vue&type=script&lang=js"
export * from "./Pendency.vue?vue&type=script&lang=js"
import style0 from "./Pendency.vue?vue&type=style&index=0&id=6da70799&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports